module.exports = __webpack_public_path__ + "static/media/49850024-v9T0wSgs.11913ed7.JPG";